import styled from "styled-components";
import { Colors } from "../../Styles/colors";

export const Button = styled.button`
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    &:hover {
        background-color: ${Colors.primary.orange}
    }
    text-decoration:none;
    color: #FFFFFF;
    border-radius:4px;
    transition:all 0.4s ease-out;
    padding:0.5rem 1rem;
    @media screen and (max-width:960px) {
        width:100%;
        display:table;
        padding:0.5rem;
        text-align:center;
    }
`;

export const Title = styled('h2')`
  color:${Colors.primary.blue};
  text-align:center;
  font-size:50px;
  border-bottom: 2px solid ${Colors.primary.orange};
  margin-bottom: 10px;
`;

export const StyledButton = styled(Button)(({theme})=>({
  width:'50%',
  alignSelf:'center',
  color:`white`,
  backgroundColor:`${Colors.primary.orange}`,
  fontSize:'16px',
  '&:hover': {
    backgroundColor: `${Colors.primary.blue}`,
  },
}));